 document.addEventListener('DOMContentLoaded', function () {
   const splideElements = document.querySelectorAll('.ab-flower-bouquet-slider');

   splideElements.forEach(function(element) {
     const splide = new Splide(element, {
       type: 'slide',
       perPage: 7,
       lazyLoad: true,
       pagination: false,
       arrows: true,
       gap: 10,
       breakpoints: {
         1200: { perPage: 6 },
         900: { perPage: 5 },
         500: { perPage: 4 },
         400: { perPage: 3 }
       }
     });
     splide.mount();
   });
  
 });